import { ProjectSetting } from "./settings/ProjectSettings";

export class DesignScene {

    public projectSetting: ProjectSetting;

    constructor() {
        this.projectSetting = new ProjectSetting();
    }
}